import { common_CLEAR_DATA } from '../actions/common'
import type { TReduxAction } from '../actions'
import { location_SELECT_TAB, location_SET_MAP_LOCATIONS } from '../actions/location'
import type { Type_ILocation } from '../../../zap/Type/Type.hive'

export const enum ETab {
    timeline = 'timeline',
    info = 'info',
    preview = 'preview',
}

export type TLocationState = {
    selectedTab: ETab
    mapLocations: Type_ILocation[]
}

const initialState = {
    selectedTab: ETab.timeline,
    mapLocations: [] as Type_ILocation[],
}

export function locationReducer(state: TLocationState = initialState, action: TReduxAction): TLocationState {
    switch (action.type) {
        case location_SELECT_TAB:
            return {
                ...state,
                selectedTab: action.tab,
            }

        case location_SET_MAP_LOCATIONS:
            return {
                ...state,
                mapLocations: action.locations,
            }

        case common_CLEAR_DATA:
            return initialState

        default:
            return state
    }
}
